import React from 'react';
import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import CalloutStats from './CalloutStats';
import StatBarChart from './Chart/StatBarChart';
import Quote from './Quote';
import TwoColumnImageText from './TwoColumnImageText';
import { DWB21_Cream, DWB21_Peach } from './colors';

const Wrapper = styled.div`
    max-width: 1440px;
`;

export default function Balance() {
    return (
        <Wrapper>
            <TwoColumnImageText
                variations={['copy-first']}
                backgroundColor={DWB21_Peach}
                heading="Striking a balance & finding success"
                subHeading="The wins that come when the world works from home."
                mediaProps={{
                    fallbackImageUrl: publicImageUrl('design-without-borders/striking-balance.gif'),
                    height: { extraLarge: '90%', large: '90%', normal: '70%', medium: '100%' },
                }}
                borderBottom={true}
                bottom={
                    <CalloutStats
                        side={<StatBarChart score={71} color={DWB21_Cream} direction="vertical" />}
                        stats={'71%'}
                        body={'of freelance designers expect their income to increase in 2022'}
                    />
                }
            >
                While designers are more selective about the work they do, they’re also finding
                greater balance and financial freedom. The majority of designers (60%) stated their
                work-life balance has improved this year, allowing them to reconnect with their main
                motivation for freelancing: personal flexibility and freedom. The global shift to
                remote work has also created increased opportunities, with 68% saying clients and
                agencies are more open to working with freelance talent than before the pandemic.
            </TwoColumnImageText>
            <Box height="80px"></Box>
            <Quote
                backgroundColor={DWB21_Peach}
                text={`When I became a full-time freelancer, the major worry was being able to 
                keep up with the same financial status as I was used to. This year I finally managed to 
                surpass my previous job in terms of income and I consider that a win.`}
                designerName={'Kosala Liyanage, Sri Lanka'}
            />
        </Wrapper>
    );
}
